export default (app, moduleName, moduleKnowledgeBase) => moduleKnowledgeBase;
